import { Component, Inject, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { USER_AUTHENTICATION_SERVICE, UserAuthInterface } from 'app/core/services';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
    selector: 'app-support-user-info-modal',
    templateUrl: './support-user-info-modal.component.html',
    // styleUrls: ['./support-user-info-modal.component.css'],

    standalone: false
})
export class SupportUserInfoModalComponent implements OnInit {
    //#region Feilds
    storeName: string;
    modalHeader: string;
    messageToShow: string;
    supportShifts: any[] = [];
    hasError = false;
    //#endregion

    //#region Constructor
    constructor(
        public activeModal: NgbActiveModal,
        private _loaderService: NgxUiLoaderService,
        @Inject(USER_AUTHENTICATION_SERVICE) private _userAuthInterface: UserAuthInterface
    ) { }
    //#endregion

    //#region Methods
    ngOnInit(): void {
        this.loadSupportUserInfo();
    }

    loadSupportUserInfo() {
        this.hasError = false;
        this._loaderService.start();
        this._userAuthInterface.getSupportUserInfo().subscribe({
            next: (res) => {
                this._loaderService.stop();
                this.supportShifts = res?.data ?? [];
            },
            error: (error) => {
                this._loaderService.stop();
                this.hasError = true;
            }
        });
    }

    formatTime(time: string): string {
    if (!time) return '';

    const [hourStr, minuteStr] = time.split(':');
    let hour = parseInt(hourStr, 10);
    const minute = minuteStr ?? '00';
    const period = hour >= 12 ? 'PM' : 'AM';

    hour = hour % 12;
    if (hour === 0) hour = 12;

    // Only show minutes if they're non-zero, e.g. "10 AM" vs "10:30 AM"
    return minute === '00' ? `${hour} ${period}` : `${hour}:${minute} ${period}`;
}

    confirm() {
        this.activeModal.close(true);
    }

    cancel() {
        this.activeModal.close(false);
    }
    //#endregion
}
